import React from 'react';
import Immutable from 'immutable';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';
import { Node } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { NodeArticle } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface ViewArticleHighlightsProps {
  entities: Immutable.List<ImmutableEntity<NodeArticle>>;
}

const ViewArticleHighlights: React.FC<ViewArticleHighlightsProps> = ({ entities }) => {
  const defaultProps = {
    autoplay: false,
  };

  return (
    <div className="ArticleHighlights">
      <Container>
        <div className="row ArticleHighlights__Teasers">
          {
            entities.map((entity, index) => {
              const id = entity.getIn(['nid', 0, 'value']);
              const uuid = entity.getIn(['uuid', 0, 'value']);
              const langcode = entity.getIn(['langcode', 0, 'value']);
              const key = `${uuid}:${langcode}`;

              return (
                <div key={uuid} className={`col-12 ${index < 1 ? '' : 'col-lg-4'}`}>
                  <Node
                    key={key}
                    entity={entity}
                    viewMode="teaser"
                    large={index < 1}
                    classes="ArticleTeaser--slide"
                  />
                </div>
              );
            })
          }
        </div>
      </Container>
    </div>
  );
};

export default ViewArticleHighlights;
